import { MutationHookOptions, useMutation } from '@apollo/client';

import { DeleteUserConfiguration, DeleteUserConfigurationVariables } 
  from '@/graphql/contracts/_generated_/deleteUserConfiguration.mutation';
import DeleteUserConfigurationQuery from '@/graphql/contracts/deleteUserConfiguration.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

const defaultOptions = { client: apolloClientContracts } as const;

export function useDeleteUserConfiguration(
  baseOptions?: MutationHookOptions<DeleteUserConfiguration, DeleteUserConfigurationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation<DeleteUserConfiguration, DeleteUserConfigurationVariables>(DeleteUserConfigurationQuery, options);
}